module.exports = __webpack_public_path__ + "static/media/F_I_P.229d2061.png";